var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wind"}},[_c('iframe',{attrs:{"id":"windIframe","src":_vm.url,"frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }